





























































































import Component from 'vue-class-component'
import Vue from 'vue'
import { State, Mutation } from 'vuex-class'
import Rate from '@/modules/shipping/model/Rate'
import Region from '@/modules/shipping/model/Region'
import RegionDetailMode from '@/modules/shipping/model/RegionDetailMode'
import RegionDetail from '@/modules/shipping/components/RegionDetail.vue'
import RateDetailMode from '../model/RateDetailMode'


    /**
     * Lista de regiones de una tarifa
     *
     * Muestra las zonas y regiones registradas en una tarifa
     *
     * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
     */
@Component({
        components: {
            'region-detail': RegionDetail,
        },
    })
    export default class RegionList extends Vue {

        @State(state => state.shipping.regionDetailMode)
        public regionDetailMode: RegionDetailMode

        /**
         * Obtenemos el detalle de la tarifa, si está en creación
         * o editándose, para permitirle al usuario añadir o no regiones
         */
        @State(state => state.shipping.rateDetailMode)
        public mode: RateDetailMode

        /**
         * Tarifa actualmente en edición
         */
        @State(state => state.shipping.currentRate)
        public rate: Rate

        get regions (): Region[] {
            const regions: Region[] = this.$store.getters['shipping/regions'](this.rate)

            return regions.sort((a, b) => {
                if (!a.isZone && !b.isZone) {
                    return 0
                }

                if (a.isZone && !b.isZone) {
                    return -1
                }

                if (!a.isZone && b.isZone) {
                    return 1
                }

                return 0
            })
        }

        @Mutation('shipping/setCurrentRegion')
        public setCurrentRegion: (region: Region) => void

        @Mutation('shipping/setRegionDetailMode')
        public setRegionDetailMode: (mode: RegionDetailMode) => void

        /**
         * Elimina una región en el estado
         */
        @Mutation('shipping/rate/current/region/remove')
        public deleteRegion: (region: Region) => void

        get regionDetail (): boolean {
            return this.regionDetailMode !== RegionDetailMode.None
        }

        public editRegion (region: Region) {
            this.setRegionDetailMode(RegionDetailMode.Editing)
            this.setCurrentRegion(region)
        }
    }
